<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import ScaleLine from 'ol/control/ScaleLine';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        props: {
            scaleBar: {
                type: Boolean,
                default: false
            },
            scaleBarSteps: {
                type: Number,
                default: 4
            },
            scaleBarText: {
                type: Boolean,
                default: true
            },
            scaleBarUnits: {
                type: String,
                default: 'metric'
            },
        },
        data()
        {
            return {
                idPanel: 'scaleline',
                className: 'ol-scale-line',
            }
        },
        methods: {
            addButtonMap: function(_map){
                let panel = _map.getPanel(this.posBtnMap, {'subposition': this.subPosBtnMap});
                if(panel) {
                    let ctrl = new ScaleLine({
                        className: 'ol-scale-line', //_map.getControlClassName(this.orderClassName),
                        units: this.scaleBarUnits,
                        bar: this.scaleBar,
                        steps: this.scaleBarSteps,
                        text: this.scaleBarText,
                        target: panel.getElement(this.subPosBtnMap),
                    });
                    _map.addControlOL(ctrl);
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>